import StoreUtil from '@store/StoreUtil';
import Message from '@core/models/user/messages/Message';
import UserService from '@core/services/user/UserService';
import { shouldChooseGdprConsent } from '@core/models/user/UserDataService';
import Modals from '@store/modules/ui/shared/modal/modals';
import { Dispatch } from 'vuex';

const actionCompletedModal = {
    code: Modals.error.code,
    data: {
        text: {
            content: 'This action has already been completed',
        }
    }
};

export default {
    namespaced: true,

    actions: {
        showPendingMessages: StoreUtil.asyncErrorGuard(async ({ dispatch }: { dispatch: Dispatch }) => {
            await dispatch('_showGdprMessage');
        }),

        async showBonusMessages({ dispatch } : { dispatch: Dispatch }) {
            const messages = await UserService.getInstance().fetchMessages();
            dispatch('_showNextBonusMessage', messages);
        },

        respondAndShowNextBonusMessage: StoreUtil.asyncErrorGuard(
            async ({ dispatch }: { dispatch: Dispatch }, actionId: number) => {
                // this method is called from the component
                // this keeps happening until there are no more bonus messages to show
                try {
                    const messages = await UserService.getInstance().respondToMessage(actionId);
                    dispatch('ui/modal/closeModal', null, { root: true });
                    dispatch('_showNextBonusMessage', messages);
                    dispatch('ui/user/account/getBalance', null, { root: true });
                } catch (e) {
                    dispatch('ui/modal/closeModal', null, { root: true });
                    dispatch('ui/modal/pushModal', actionCompletedModal , { root: true });
                }
            }
        ),

        _showGdprMessage({ dispatch, rootGetters }: { dispatch: Dispatch, rootGetters: any }) {
            const user = rootGetters['data/authentication/user'];
            if (!user) {
                return;
            }

            if (shouldChooseGdprConsent(user)) {
                dispatch('ui/modal/pushModal', Modals.chooseGdpr.code, { root: true });
            } else {
                dispatch('showBonusMessages', user);
            }
        },

        _showWelcomeBonusMessage({ dispatch, rootGetters } : { dispatch: Dispatch, rootGetters: any }) {
            const user = rootGetters['data/authentication/user'];
            if (user && user.welcomeBonus) {
                dispatch('ui/modal/pushModal', Modals.welcomeBonusIntro.code, { root: true });
            }
        },

        _showNextBonusMessage({ dispatch } : { dispatch: Dispatch }, messages: Message[]) {
            const nextMessage = messages.shift();
            if (!nextMessage) {
                dispatch('_showWelcomeBonusMessage');
                return;
            }

            dispatch(
                'ui/modal/pushModal',
                {
                    code: Modals.message.code,
                    goBack: true,
                    afterClose: () => dispatch('_showWelcomeBonusMessage'),
                    data: nextMessage
                },
                { root: true }
            );
        },
    }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/store/modules/ui/user/messages/messagesIndex.ts